import { defineMessages } from "react-intl";
const messages = defineMessages({
    aiDiscoverabilityDashboardLogout: {
        id: "aiDiscoverability.dashboard.logout",
        defaultMessage: "Log Out",
    },
    aiDiscoverabilityDashboardPlansBilling: {
        id: "aiDiscoverability.dashboard.plansBilling",
        defaultMessage: "Plans & Billing",
    },
    reportNavigationLatest: {
        id: "app.aiDiscoverability.reportNavigation.latest",
        defaultMessage: "Newest",
    },
    reportNavigationPrevious: {
        id: "app.aiDiscoverability.reportNavigation.previous",
        defaultMessage: "Previous Reports",
    },
    reportNavigationTitle: {
        id: "app.aiDiscoverability.reportNavigation.title",
        defaultMessage: "Reports",
    },
    reportNavigationViewMore: {
        id: "app.aiDiscoverability.reportNavigation.viewMore",
        defaultMessage: "View More",
    },
    reportNavigationViewLess: {
        id: "app.aiDiscoverability.reportNavigation.viewLess",
        defaultMessage: "View Less",
    },
    reportNavigationOther: {
        id: "app.aiDiscoverability.reportNavigation.other",
        defaultMessage: "Other",
    },
    reportNavigationSettings: {
        id: "app.aiDiscoverability.reportNavigation.settings",
        defaultMessage: "Report Settings",
    },
    reportNavigationReportType: {
        id: "app.aiDiscoverability.reportNavigation.reportType",
        defaultMessage: "Report {number}",
    },
    reportNavigationReportTypeWithName: {
        id: "app.aiDiscoverability.reportNavigation.reportTypeWithName",
        defaultMessage: "V{number} - {name}",
    },
    reportNavigationSettingsTitle: {
        id: "app.aiDiscoverability.reportNavigation.settingsTitle",
        defaultMessage: "Settings",
    },
    reportNavigationInactive: {
        id: "app.aiDiscoverability.reportNavigation.inactive",
        defaultMessage: "inactive",
    },
    reportNavigationPaused: {
        id: "app.aiDiscoverability.reportNavigation.paused",
        defaultMessage: "Inactive",
    },
    reportNavigationNextRunOn: {
        id: "app.aiDiscoverability.reportNavigation.nextRunOn",
        defaultMessage: "Next Run On",
    },
    reportNavigationNotRunYet: {
        id: "app.aiDiscoverability.reportNavigation.notRunYet",
        defaultMessage: "This report hasn't been ran yet.",
    },
});
export default messages;
